import { Injectable } from "@angular/core";
import { ActivatedRoute, ResolveEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class HeaderService {


    private HeaderAltReturnUrl$$: BehaviorSubject<string> = new BehaviorSubject<string>('/home');
    private HeaderAltTitle$$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private IsAltNav$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private toggleHeader$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private altNavCancelProgress$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);


    public HeaderAltTitle$ = this.HeaderAltTitle$$.asObservable();
    public HeaderAltReturnUrl$ = this.HeaderAltReturnUrl$$.asObservable();
    public IsAltNav$ = this.IsAltNav$$.asObservable();
    public toggleHeader$ = this.toggleHeader$$.asObservable();
    public altNavCancelProgress$ = this.altNavCancelProgress$$.asObservable();
    currentRoute: string = '';

    public toggleHeader() {
        this.toggleHeader$$.next(!this.toggleHeader$$.value);
    }

    public setAltNavigation(title?: string, returnUrl?: string) {
        this.IsAltNav$$.next(true);
        if (title) {
            this.HeaderAltTitle$$.next(title);
        }
        if (returnUrl) {
            console.log('New Return url', returnUrl)
            this.HeaderAltReturnUrl$$.next(returnUrl);
        }
    }

    public removeAltNav() {
        this.IsAltNav$$.next(false);
    }

    public clearReturnUrl() {
        this.HeaderAltReturnUrl$$.next('/home');
    }

    public showCancelProgress(disable: boolean) {
        this.altNavCancelProgress$$.next(disable);
    }

    constructor(private router: Router) {
        this.router.events.subscribe((routerData) => {
            if (routerData instanceof ResolveEnd) {
                this.currentRoute = routerData.url;
                if (
                    this.currentRoute.includes('welcome') ||
                    this.currentRoute.includes('on-boarding')
                ) {
                    this.IsAltNav$$.next(true);
                    this.HeaderAltTitle$$.next('onboarding.onboarding-welcome.anchors.knowYourNeeds');

                } else if (routerData.url.includes('property-upload-wizard')) {
                    this.IsAltNav$$.next(true);
                    this.HeaderAltTitle$$.next('property-upload-wizard.alternavTitle');

                } else if (routerData.url.includes('loan-eligibility')) {
                    this.IsAltNav$$.next(true);
                    this.HeaderAltTitle$$.next('loan-wizard.eligibilityCheck.alternavTitle');

                } else if (routerData.url.includes('loan-application')) {
                    this.IsAltNav$$.next(true);
                    this.HeaderAltTitle$$.next('loan-wizard.loanApplication.alternavTitle');

                } else if (this.currentRoute.includes('brokerage-agreement')) {
                    this.IsAltNav$$.next(true);
                    this.HeaderAltTitle$$.next('my-profile.selling.selling-details.overview.brokerage-aggreement.alternavTitle');
                }
                else if (this.currentRoute.includes('upload-photos')) {
                    this.IsAltNav$$.next(true);
                    this.HeaderAltTitle$$.next('my-profile.selling.selling-details.overview.upload-photos.alternavTitle');
                }
                else {
                    this.IsAltNav$$.next(false);
                }
            }
        });
    }
}